import React, { useEffect } from "react";

import { ContentCard } from "../../components/content_card/ContentCard.js";

import { StepOne } from "./StepOne.js";
import { StepTwo } from "./StepTwo.js";
import { StepThree } from "./StepThree.js";
import { StepFour } from "./StepFour.js";
import { StepFive } from "./StepFive.js";
import SuccessUploadScene from "../upload_result/SuccessUploadScene.js";
import FailUploadScene from "../upload_result/FailUploadScene.js";

import { useProcessStore, useAuthenticationStore } from "../../stores/generalStore";
import { useNavigate } from "react-router";

const ReturnStockCSSScene = () => {
	// zustand stores slicing
	const currentProcess = useProcessStore((state) => state.currentProcess);
	const clearProcessData = useProcessStore((state) => state.clearProcessData);
	const currentStep = useProcessStore((state) => state.currentStep);
	const orderResult = useProcessStore((state) => state.orderResult);
	const userRole = useAuthenticationStore((state) => state.userRole);

	const navigate = useNavigate();

	// scene interaction methods
	useEffect(() => {
		if ( userRole !== "CSS" && userRole !== "CSS_IR" ) navigate('/');
		if (currentProcess !== "SO_based") clearProcessData("SO_based");
	}, [currentProcess, clearProcessData, userRole]);

	// current screen decision
	return (
		<>

			{
				(currentStep < 5) 
				&& 
				<ContentCard
					location={"return_step collapsed form_heading"}
					width="520"
				>
					<h2>Objednávka svozu {userRole.replace("X", "")}</h2>
				</ContentCard>
			}
			{(currentStep < 5) && <StepOne />}
			{(currentStep < 5) && <StepTwo />}
			{(currentStep < 5) && <StepThree />}
			{(currentStep < 5) && <StepFour />}
			{(currentStep < 5) && <StepFive />}
			{(currentStep === 5 && orderResult === 'Complete') && <SuccessUploadScene />}
			{(currentStep === 5 && orderResult === 'Error') && <FailUploadScene />}
		
		</>
	);
};

export default ReturnStockCSSScene;
